// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inspection-first .test-item[data-v-d9e09090]:after{border:none}.inspection-first .check-items[data-v-d9e09090]{padding:0 16px}.inspection-first .check-items .items[data-v-d9e09090]{padding:5px 0}", ""]);
// Exports
module.exports = exports;
